import { inventoryFilterUserPath } from "~/routes";

import { createSearchStore } from "./create-search-store";

export const useInventorySearch = createSearchStore({
  path: inventoryFilterUserPath,
  resultsKey: "inventories",
  extraParams: ({ supplierId = null, excludeSubrecipes = false } = {}) => ({
    ...(supplierId && { supplier_id: supplierId }),
    ...(excludeSubrecipes && { exclude_subrecipes: "true" }),
  }),
});
